import { Link, Spacer, Text } from '@sparemin/blockhead';
import React from 'react';
import { Alert } from 'components/icons';
import { block } from './utils';

export type VideoWizardNoMostReplayedDataProps = {};

const VideoWizardNoMostReplayedData: React.FC<VideoWizardNoMostReplayedDataProps> = () => {
  return (
    <Spacer
      space="14px"
      orientation="horizontal"
      align="flex-start"
      justify="space-between"
      className={block('no-most-replayed-data')}
    >
      <Alert width="21px" height="21px" fill="#f29e5e" />

      <Text
        variant="label"
        align="start"
        lineHeight="20px"
        className={block('alert-label')}
      >
        Your video doesn't yet have "Most Replayed" momements.
        <br />
        To have Headliner auto-create clips for you, click next.{' '}
        <Link
          href="https://learn.headliner.app/hc/en-us/articles/31118501939479/"
          target="_blank"
          className={block('learn-more')}
        >
          Learn more
        </Link>
      </Text>
    </Spacer>
  );
};

export default VideoWizardNoMostReplayedData;
